import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BuildInfo, FRONTEND_BUILD, formatVersion, versionsAbweichung } from '../../version';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

/**
 * Fußzeile der Einstellungen: welcher Stand läuft hier?
 * Frontend-Stand kommt aus dem Bundle, Backend-Stand aus /api/health.
 * Weichen beide ab (halb durchgelaufenes Deploy), wird das markiert.
 */
const VersionFooter: React.FC = () => {
  const [backend, setBackend] = useState<BuildInfo | null>(null);

  useEffect(() => {
    let aktiv = true;
    axios.get(`${API_URL}/api/health`)
      .then(res => { if (aktiv && res.data?.version) setBackend(res.data.version as BuildInfo); })
      .catch(() => { /* Health nicht erreichbar – Fußzeile zeigt nur das Frontend */ });
    return () => { aktiv = false; };
  }, []);

  const abweichung = backend ? versionsAbweichung(FRONTEND_BUILD.git_sha, backend.git_sha) : false;
  const tag = backend?.image_tag ?? FRONTEND_BUILD.image_tag;
  const details = [
    `Frontend: ${FRONTEND_BUILD.git_sha}${FRONTEND_BUILD.build_time ? ` (${FRONTEND_BUILD.build_time})` : ''}`,
    backend ? `Backend: ${backend.git_sha}${backend.build_time ? ` (${backend.build_time})` : ''}` : 'Backend: nicht erreichbar',
    FRONTEND_BUILD.git_branch ? `Branch: ${FRONTEND_BUILD.git_branch}` : null,
  ].filter(Boolean).join('\n');

  return (
    <div className={`settings-nav-version${abweichung ? ' abweichung' : ''}`} title={details}>
      <div>AgenticERP{tag ? ` · ${tag}` : ''}</div>
      <div>{formatVersion(FRONTEND_BUILD)}</div>
      {abweichung && backend && (
        <div className="settings-nav-version-hinweis">
          Backend auf anderem Stand ({backend.git_sha_short})
        </div>
      )}
    </div>
  );
};

export default VersionFooter;
